/* Thank-you post-purchase upsell — countdown 5min + szybki zakup → child order → payment redirect.
 * Server-side jest source of truth dla time window; klient nie może przedłużyć czasu manipulacją clock.
 */
(function () {
	var root = document.querySelector('[data-kb-upsell]');
	if (!root) return;

	var timerEl   = root.querySelector('[data-kb-upsell-timer]');
	var timerText = root.querySelector('[data-kb-upsell-timer-text]');
	var expiredEl = root.querySelector('[data-kb-upsell-expired]');
	var buyBtns   = root.querySelectorAll('[data-kb-upsell-buy]');

	var secsLeft = parseInt(root.getAttribute('data-secs-left') || '0', 10);
	var orderId  = root.getAttribute('data-order-id');
	var orderKey = root.getAttribute('data-order-key');
	var restUrl  = root.getAttribute('data-rest');

	function render() {
		if (!timerText) return;
		var m = Math.floor(secsLeft / 60);
		var s = secsLeft % 60;
		timerText.textContent = m + ':' + (s < 10 ? '0' + s : s);
		if (secsLeft <= 60 && timerEl) timerEl.classList.add('is-low');
	}

	function expire() {
		root.classList.add('is-expired');
		if (expiredEl) expiredEl.hidden = false;
		buyBtns.forEach(function (b) { b.disabled = true; });
	}

	// Ładny toast zamiast alert() — dołączony pod panelem.
	function toast(msg, kind) {
		var el = document.createElement('div');
		el.className = 'kb-upsell-toast kb-upsell-toast-' + (kind || 'info');
		el.textContent = msg;
		root.appendChild(el);
		setTimeout(function () { el.classList.add('is-visible'); }, 10);
		setTimeout(function () {
			el.classList.remove('is-visible');
			setTimeout(function () { el.remove(); }, 300);
		}, 3500);
	}

	function showError(btn, msg) {
		toast(msg, 'error');
		btn.disabled = false;
		btn.classList.remove('is-loading');
	}

	function markAsAdded(btn, msg) {
		toast(msg, 'success');
		btn.disabled = true;
		btn.classList.remove('is-loading');
		btn.classList.add('is-added');
		var lbl = btn.querySelector('.kb-upsell-buy-label');
		if (lbl) lbl.textContent = '✓ Dodano';
	}

	function tick() {
		if (secsLeft <= 0) { expire(); return; }
		secsLeft--;
		render();
	}

	if (secsLeft > 0) {
		render();
		var iv = setInterval(function () {
			tick();
			if (secsLeft <= 0) clearInterval(iv);
		}, 1000);
	} else {
		expire();
	}

	buyBtns.forEach(function (btn) {
		btn.addEventListener('click', function () {
			if (btn.disabled || secsLeft <= 0) return;
			var pid = parseInt(btn.getAttribute('data-product-id'), 10);
			if (!pid) return;

			btn.disabled = true;
			btn.classList.add('is-loading');

			fetch(restUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				credentials: 'same-origin',
				body: JSON.stringify({
					parent_order_id: parseInt(orderId, 10),
					order_key: orderKey,
					product_id: pid,
				}),
			})
				.then(function (r) {
					return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; });
				})
				.then(function (res) {
					// COD: parent za pobraniem → child też, bez oddzielnej płatności.
					if (res.ok && res.body && res.body.cod) {
						markAsAdded(btn, res.body.message || 'Dodano do zamówienia!');
						return;
					}
					// Standard: redirect do payment page dla drugiej transakcji.
					if (res.ok && res.body && res.body.payment_url) {
						window.location.href = res.body.payment_url;
						return;
					}
					var msg = (res.body && (res.body.message || (res.body.data && res.body.data.msg))) || 'Nie udało się utworzyć zamówienia. Odśwież stronę i spróbuj ponownie.';
					showError(btn, msg);
					if (res.status === 410) expire();
				})
				.catch(function () {
					showError(btn, 'Brak połączenia. Spróbuj ponownie.');
				});
		});
	});
})();
